import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { API_ROUTES } from "../../routes/apiRoutes";

export const useCustomerBuildingReports = (buildingId) => {
  return useQuery({
    queryKey: ["customer-building-reports", buildingId],
    queryFn: async () => {
      const { data } = await api.get(API_ROUTES.BUILDING_DETAILS(buildingId));
      return data;
    },
    enabled: !!buildingId,
    select: (data) => data?.data?.overviewImages || [],
  });
};
